export const ScrollHorizontalComponent = {
  bindings: {},
  transclude: true,
  templateUrl: 'components/Scroll/scroll-horizontal/scroll-horizontal.html',
};
